<!--  -->
<template>
    <div class="suggestion">
        <div class="guide-block"></div>
        <suggestion-sort />
        <div class="guide-block"></div>
        <question />
        <telephonne />
        <dialog-slot :isTitle="true" :show.sync="showDialog" leftBtnText="查看详情" @handleLeftBtn="detail">
            <template v-slot:title>
                <div v-if="messageData.feedbackOpinionType == 1">订单申诉回复提醒</div>
                <div v-if="messageData.feedbackOpinionType == 2">投诉建议回复提醒</div>
            </template>
            <template v-slot:content>
                <div class="dialog-container">您投诉的 {{ messageData.complaintContent }} 已核实处理</div>
            </template>
        </dialog-slot>
    </div>
</template>

<script>
import SuggestionSort from "@/components/suggestion/suggestion-sort.vue";
import Question from "@/components/question/question.vue";
import DialogSlot from "@/components/base/dialogSlot/dialog-slot.vue";
import Telephonne from "@/components/telephone";
export default {
    name: "Suggestion",
    components: {
        SuggestionSort,
        Question,
        DialogSlot,
        Telephonne,
    },
    data() {
        return {
            showDialog: false,
            messageData: {},
        };
    },

    computed: {},
    mounted() {},

    methods: {
        detail() {
            this.showDialog = false;
            let query = {
                tpye: this.messageData.feedbackOpinionType,
                id: this.messageData.id,
            };
            this.$router.push({
                query: query,
                path: "/suggestion/orderAppeal/orderAppealDetail",
            });
        },
        handleConfirm() {
            this.showDialog = false;
        },
    },
};
</script>
<style lang="less" scoped>
.guide-block {
    height: 16px;
}

.tel {
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 28px;
}
.suggestion {
    min-height: 100vh;
    overflow: scroll;
    background-color: #f5f8fa;
}

.dialog-container {
    text-align: center;
    margin: 56px auto 56px auto;
    font-size: 28px;
}
</style>
